export default "__VITE_ASSET__BNQtU5i$__"